import React from "react";
import { BadgeCheck, PenLine, PlusCircle, BoxIcon } from "lucide-react";
import { useResearchDemo } from "../../contexts/ResearchDemoContext";
import { ResearchHistoryEvent } from "../../types/researchDemo";
import { DemoSectionHeader } from "../demoShell/DemoSectionHeader";
import { HistoryControls } from "../demoShell/HistoryControls";
import { downloadJson, formatTimestamp } from "../../utils/demoStorage";
import { linkButton } from "../../utils/demoUi";
import { researchExport } from "../../utils/researchDemo";
const kindIcon: Record<ResearchHistoryEvent['kind'], BoxIcon> = {
  proposal: PlusCircle,
  review: BadgeCheck,
  note: PenLine
};
const kindLabel: Record<ResearchHistoryEvent['kind'], string> = {
  proposal: 'Proposal',
  review: 'Review decision',
  note: 'Research note'
};
export function ResearchHistory() {
  const {
    state,
    reset,
    openClaim,
    inspectSource
  } = useResearchDemo();
  return <div data-id="element-2220" data-mp="1ka3mihdmj82e">
      <DemoSectionHeader title="Review History" description="Every proposal, review decision and saved note, newest first. Shared by both Research workspaces." data-id="element-2221" data-mp="1kadeubm55rb9" />

      <div className="grid grid-cols-1 gap-8 xl:grid-cols-[minmax(0,7fr)_minmax(0,4fr)]" data-id="element-2222" data-mp="1wxm8mk9gqnwa">
        <ol className="space-y-1 border-l border-line pl-6" data-id="element-2223" data-mp="20zh95mjkkx90">
          {state.history.map(event => {
          const Icon = kindIcon[event.kind];
          return <li key={event.id} className="relative pb-5" data-id="element-2224" data-mp="25stspi9e6duw">
                <span className="absolute -left-[2.3rem] top-0 flex h-7 w-7 items-center justify-center rounded-full border border-line bg-white text-lavender" data-id="element-2225" data-mp="2aor02z2og9vj">
                  <Icon size={14} aria-hidden="true" data-id="element-2226" data-mp="2knzxy30ny8n6" />
                </span>
                <p className="text-xs text-ink-muted" data-id="element-2227" data-mp="2klvkougvjxa8">
                  {kindLabel[event.kind]} · {formatTimestamp(event.at)} · <span className="font-mono" data-id="element-2228" data-mp="2on8rb6rsk4i7">{event.id}</span>
                </p>
                <p className="mt-1 font-semibold text-ink-dark" data-id="element-2229" data-mp="qc1ru9xnhsvi">{event.title}</p>
                <p className="mt-0.5 text-sm leading-relaxed text-ink-muted" data-id="element-2230" data-mp="uc2f8k2q9eep">{event.detail}</p>
                {event.claimId && <button type="button" onClick={() => openClaim(event.claimId as string)} className={`mt-1.5 ${linkButton}`} data-id="element-2231" data-mp="1xmpykq3xqz24">
                    Open evidence record
                  </button>}
                {event.sourceId && <button type="button" onClick={() => inspectSource(event.sourceId as string)} className={`mt-1.5 ${linkButton}`} data-id="element-2232" data-mp="26ktbwz4ropiu">
                    Inspect {event.sourceId}
                  </button>}
              </li>;
        })}
        </ol>

        <div className="xl:sticky xl:top-28 xl:self-start" data-id="element-2233" data-mp="2bn0sy34gevs1">
          <HistoryControls domainName="Research" exportLabel="Export research records" onExport={() => downloadJson('noetivra-research-records.json', researchExport(state))} onReset={reset} data-id="element-2234" data-mp="2bkejtz1x087p" />
        </div>
      </div>
    </div>;
}